import { useRenderNode } from "./useRenderNode";

export const CraftJsonRenderer = ({ craftJson }) => {
  const renderNode = useRenderNode();
  const parseCraft = JSON.parse(craftJson);

  return renderNode(parseCraft["ROOT"], parseCraft);
};
